import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchCoinPoolCurrentRound } from "../redux/coinPoolSlice";
import { COIN_POOL_FAST_POLL_STATUSES } from "../utils/coinPoolHelpers";

export function useCoinPoolPolling(round, enabled = true) {
  const dispatch = useDispatch();
  const statusRef = useRef(round?.status);

  useEffect(() => {
    statusRef.current = round?.status;
  }, [round?.status]);

  useEffect(() => {
    if (!enabled) return undefined;

    const poll = () => {
      dispatch(fetchCoinPoolCurrentRound());
    };

    poll();
    const intervalMs = COIN_POOL_FAST_POLL_STATUSES.includes(statusRef.current) ? 1500 : 4000;
    const id = window.setInterval(poll, intervalMs);
    return () => window.clearInterval(id);
  }, [dispatch, enabled, round?.status]);
}
